// src/mobile_pages/system/User_add.jsx
import React, { useEffect, useState } from "react";
import api from "../../api/axios";
import MobileSingleUserForm from "../../components/forms/mobile/MobileSingleUserForm";
import MobileBulkUserImport from "../../components/forms/mobile/MobileBulkUserImport";
import { UserPlus, Users, FileSpreadsheet } from "lucide-react";

export default function User_add() {
  const [tab, setTab] = useState("single"); // single | bulk
  const [companies, setCompanies] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [positions, setPositions] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const [c, d, p] = await Promise.all([
          api.get("companies/"),
          api.get("departments/"),
          api.get("positions/"),
        ]);
        setCompanies(c.data?.results ?? c.data ?? []);
        setDepartments(d.data?.results ?? d.data ?? []);
        setPositions(p.data?.results ?? p.data ?? []);
      } catch (e) {
        console.error(e);
      }
    })();
  }, []);

  return (
    <div className="mobile-page-root">
      <div className="mobile-page-root-inner space-y-4 mobile-bottom-spacing">
        {/* Header */}
        <div className="mobile-page-header">
          <div className="flex items-center gap-2">
            <UserPlus className="w-5 h-5 text-blue-600" />
            <h1 className="mobile-page-title">사용자 추가</h1>
          </div>
        </div>

        {/* Tab Switcher */}
        <div className="bg-white rounded-lg p-1 border flex gap-1">
          <button
            className={`flex-1 flex items-center justify-center gap-2 px-3 py-2.5 rounded-md text-sm font-medium transition-all ${tab === "single"
                ? "bg-blue-600 text-white"
                : "text-gray-600 hover:bg-gray-100"
              }`}
            onClick={() => setTab("single")}
          >
            <Users className="w-4 h-4" />
            단건 추가
          </button>
          <button
            className={`flex-1 flex items-center justify-center gap-2 px-3 py-2.5 rounded-md text-sm font-medium transition-all ${tab === "bulk"
                ? "bg-blue-600 text-white"
                : "text-gray-600 hover:bg-gray-100"
              }`}
            onClick={() => setTab("bulk")}
          >
            <FileSpreadsheet className="w-4 h-4" />
            엑셀 대량
          </button>
        </div>

        {/* Form Content */}
        {tab === "single" ? (
          <MobileSingleUserForm
            companies={companies}
            departments={departments}
            positions={positions}
          />
        ) : (
          <MobileBulkUserImport
            companies={companies}
            departments={departments}
            positions={positions}
          />
        )}
      </div>
    </div>
  );
}
